import { SORT_DIRECTION } from '@/shared/constants/sort/sortDirection'

const DEFAULT_STATE = {
  id: null,
  items: [],
  page: 1,
  limit: 10,
  total: null,
  formData: null,
  loading: false,
  search: null,
  sort: {
    sort_by: 'last_successful_transaction_time',
    sort_direction: SORT_DIRECTION.DESC,
  },
  actionLoading: false,

  detailSearch: null,
  detailFormData: {
    approved_count: null,
    approved_sum: null,
    in_emcd_sum: null,
    description: null,
    invited_count: null,
    in_emcd_count: null,
    name: null,
    paid_count: null,
    paid_sum: null,
    pays_error_count: null,
    raw_error_count: null,
  },
  detailItems: [],
  detailLoading: false,
  detailPage: 1,
  detailLimit: 9999,
  detailTotal: 0,
  filters: {
    contractor_statuses: [],
    payment_statuses: [],
  },
}

export default {
  ...DEFAULT_STATE,
}
